import { Component } from '@angular/core';

@Component({
  selector: 'app-crm-custom-page2',
  templateUrl: './crm-custom-page2.component.html',
  styleUrls: ['./crm-custom-page2.component.css']
})
export class CrmCustomPage2Component {

}
